import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "btn-group" }
const _hoisted_3 = { class: "your-bookings--date" }
const _hoisted_4 = { class: "your-bookings--card-job-id" }
const _hoisted_5 = { class: "your-bookings--card-car" }
const _hoisted_6 = { class: "your-bookings--card-car-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "your-bookings--card-car-info" }
const _hoisted_9 = { class: "your-bookings--card-car-info-class" }
const _hoisted_10 = {
  key: 0,
  class: "your-bookings--card-car-price"
}
const _hoisted_11 = { class: "your-bookings--card-address" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Pick up address", -1)
const _hoisted_14 = { class: "form-control-value" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Dropoff address", -1)
const _hoisted_18 = { class: "form-control-value" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Date & time", -1)
const _hoisted_22 = { class: "form-control-value" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Vehicle registration", -1)
const _hoisted_26 = ["onClick"]

import { useRouter, useRoute, RouterLink } from 'vue-router'
import { computed, onMounted, ref, nextTick, onUnmounted } from "vue";
import AccountInfoModal from "@/views/my-account/AccountInfoModal.vue";
import FaqModal from "@/views/my-account/FaqModal.vue";
import FiltersModal from "@/views/your-bookings/FiltersModal.vue";
import {
  PeriodTypeType,
  BookingGroups,
} from "@/models/your-bookings";
import BookingPaymentStatusLabel from '@/components/BookingPaymentStatusLabel.vue'
import BookingTag from '@/components/BookingTag.vue'
import { useUser } from '@/store/user'
import { useBookings } from '@/store/booking'
import dayjs from 'dayjs'
import { useIntervalFn } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'Bookings',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { isCustomer, isDriver, isAdmin } = useUser()
const { getBookings, filter, updateFilter, error, errors } = useBookings()

const bookingsDiv = ref<HTMLDivElement>()
const accountModalVisible = ref(false)
const filterModalVisible = ref(false)
const faqModalVisible = ref(false)
const bookingGroups = ref<BookingGroups[]>([])

updateFilter(route.query)

const fetchBookings = async () => {
  bookingGroups.value = await getBookings();
}

const showFilterModal = computed(() => {
  return filterModalVisible.value || Object.keys(errors.value).length > 0;
})

const toggleFilterModal = (show: boolean) => {
  filterModalVisible.value = show
}

const toggleAccountModal = (show: boolean) => {
  accountModalVisible.value = show
}

const toggleFaqModal = (show: boolean) => {
  toggleAccountModal(false)
  nextTick(() => {
    faqModalVisible.value = show
  })
}

const saveFilter = async () => {
  toggleFilterModal(false)
  await router.push({
    name: 'bookings',
    query: filter.value,
  })

  fetchBookings()
}

const nextDayBookings = () => {
  let nextDay = filter.value.startDate
  if (!nextDay) {
    nextDay = dayjs().format('YYYY-MM-DD')
  }

  nextDay = dayjs(nextDay).add(1, 'day').format('YYYY-MM-DD')

  filter.value.startDate = filter.value.endDate = nextDay
  bookingsDiv.value?.scrollIntoView({ behavior: 'smooth' })
  saveFilter()
}

const togglePeriodType = (type: PeriodTypeType) => {
  filter.value.periodType = type
  saveFilter()
}

onMounted(fetchBookings)

const { pause } = useIntervalFn(fetchBookings, 5000)
onUnmounted(pause)

return (_ctx: any,_cache: any) => {
  const _component_UserPositionBar = _resolveComponent("UserPositionBar")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppHeaderProgressBar = _resolveComponent("AppHeaderProgressBar")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UserPositionBar),
    _createVNode(_component_AppHeader, {
      title: "Your bookings",
      "account-icon": true,
      "filter-icon": "",
      onAccount: _cache[0] || (_cache[0] = ($event: any) => (toggleAccountModal(true))),
      onFilter: _cache[1] || (_cache[1] = ($event: any) => (toggleFilterModal(true)))
    }),
    _createVNode(_component_AppHeaderProgressBar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "your-bookings",
        ref_key: "bookingsDiv",
        ref: bookingsDiv
      }, [
        _createVNode(_component_Error, { error: _unref(error) }, null, 8, ["error"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn-group--btn", {
            'btn-group--btn_active': _unref(filter).periodType == 'upcoming',
          }]),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (togglePeriodType('upcoming')), ["prevent"]))
          }, " upcoming ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-group--btn", { 'btn-group--btn_active': _unref(filter).periodType == 'past' }]),
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (togglePeriodType('past')), ["prevent"]))
          }, " past ", 2)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingGroups.value, (g, k) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "your-bookings--group",
            key: k
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(g.date), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.bookings, (v) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "your-bookings--card",
                key: v.id
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(v.id), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (v.driverVehicle)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: v.driverVehicle.vehicle?.vehicleCat?.image
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(v.driverVehicle?.vehicle?.vehicleCat?.name), 1),
                    (v.paymentStatus)
                      ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                          key: 0,
                          status: v.paymentStatus
                        }, null, 8, ["status"]))
                      : _createCommentVNode("", true),
                    (v.isCancelled)
                      ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                          key: 1,
                          status: "cancelled"
                        }))
                      : _createCommentVNode("", true),
                    (_unref(isDriver) && v.hasDriverConfirmedJob)
                      ? (_openBlock(), _createBlock(BookingPaymentStatusLabel, {
                          key: 2,
                          status: "confirmed"
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.tags, (t, k) => {
                      return (_openBlock(), _createBlock(BookingTag, {
                        key: k,
                        tag: t
                      }, null, 8, ["tag"]))
                    }), 128))
                  ]),
                  (_unref(isCustomer) || _unref(isDriver))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(v.priceFormatted), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString(v.pickup), 1)
                  ]),
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(v.destination), 1)
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(v.jobStartFormatted), 1)
                  ]),
                  (_unref(isDriver) && v.vehicles?.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.vehicles, (vv, vk) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "form-control-value",
                              key: vk
                            }, _toDisplayString(vv.vehicle?.regNo), 1))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(isDriver) || _unref(isAdmin))
                    ? (_openBlock(), _createBlock(_unref(RouterLink), {
                        key: 1,
                        to: {
                  name: 'booking_details',
                  params: { id: v.id },
                  query: _unref(route).query,
                },
                        class: "btn btn-block btn-view"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("View booking details")
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_unref(isCustomer))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (v.isVehicleLocationViewable)
                            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                key: 0,
                                to: {
                  name: 'booking_vehicle_location',
                  params: { id: v.id },
                  query: _unref(route).query,
                },
                                class: "btn btn-block btn-view"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Check vehicle location")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (_openBlock(), _createBlock(_unref(RouterLink), {
                                key: 1,
                                to: {
                  name: 'booking_details',
                  params: { id: v.id },
                  query: _unref(route).query,
                },
                                class: "btn btn-block btn-view"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View booking details")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                        ], 64))
                      : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        }), 128)),
        (bookingGroups.value.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-block your-bookings--next-day-btn",
              onClick: _withModifiers(nextDayBookings, ["prevent"])
            }, "Next Day", 8, _hoisted_26))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createVNode(FiltersModal, {
      show: _unref(showFilterModal),
      "default-data": _unref(filter),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (toggleFilterModal(false))),
      onSave: saveFilter
    }, null, 8, ["show", "default-data"]),
    _createVNode(AccountInfoModal, {
      show: accountModalVisible.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (toggleAccountModal(false))),
      "onShow:faq": _cache[6] || (_cache[6] = ($event: any) => (toggleFaqModal(true)))
    }, null, 8, ["show"]),
    _createVNode(FaqModal, {
      show: faqModalVisible.value,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (toggleFaqModal(false)))
    }, null, 8, ["show"])
  ]))
}
}

})